// List of conflicting city name between different countries
// Note: Ensure key is lowercase
export const knownCityMap = new Map<string, string>([
  // Ahemdabad
  ['ahemdabad', 'Ahmedabad'],
  ['ahemdaabaad', 'Ahmedabad'],
  ['ahemdabaad', 'Ahmedabad'],
  ['ahmdabad', 'Ahmedabad'],
  ['ahmedabaad', 'Ahmedabad'],
  ['ahemdaabad', 'Ahmedabad'],
  ['amdabad', 'Ahmedabad'],
  // Ahmednagar
  ['ahmednagar', '19.095885871596657, 74.75091314592453'],
  // beed
  ['beed', '18.990625659575944, 75.75292014352237'],
  // Buldhana
  ['buldhana', 'buldana'],
  // Jalgaon Jamod
  ['jalgaon jamod', '21.049267718532672, 76.53127549263601'],
  ['jalgaonjamod', '21.049267718532672, 76.53127549263601'],
  // Shirur
  ['shirur', 'sirur'],
  ['shiroor', 'sirur'],
  ['shiror', 'sirur'],
  // Ahore or Ahor, Rajasthan
  ['ahore', '25.372366549374707, 72.77744002092237'],
  ['ahor', '25.372366549374707, 72.77744002092237'],
  // Alappuzha (or Alleppey)
  ['alleppey', 'Alappuzha'],
  // Banglore
  ['banglore', 'Bangalore'],
  // Baroda
  ['baroda', 'Vadodara'],
  // Delhi
  ['delhi', 'New Delhi'],
  ['dilli', 'New Delhi'],
  ['dilhi', 'New Delhi'],
  // HimmatNagar, Himmat nagar, Himmat nagar
  ['himmatnagar', 'Himatnagar'],
  ['himat nagar', 'Himatnagar'],
  ['himmat nagar', 'Himatnagar'],
  // Idar, Gujarat
  ['idar', '23.839452881122664, 73.0006173069727'],
  // Kosi Kalan, Mathura, UP
  ['kosi kalan', '27.787328765378213, 77.43712826801521'],
  // Palitana
  ['giriraj', 'Palitana'],
  ['siddhachal', 'Palitana'],
  ['siddhachalji', 'Palitana'],
  // Girnar
  ['girnar', '21.52545738240156, 70.55204951942684'],
  ['girnarji', '21.52545738240156, 70.55204951942684'],
  // sammed shikharji
  ['sammed shikhar', '23.97281841060183, 86.17992742139482'],
  ['sammed shikharji', '23.97281841060183, 86.17992742139482'],
  ['sammet shikhar', '23.97281841060183, 86.17992742139482'],
  ['sammet shikharji', '23.97281841060183, 86.17992742139482'],
  ['shikharji', '23.97281841060183, 86.17992742139482'],
  ['parasnath', '23.97281841060183, 86.17992742139482'],
  //nashik
  ['nashik', 'nasik'],
  // thane
  ['thane', '19.22183462147074, 72.97708438497331'],
  ['thana', '19.22183462147074, 72.97708438497331'],
  // Sanand
  ['sanand', '22.992098730614103, 72.37810325793987'],
  // Sangli
  ['sangli', '16.852721560409005, 74.58272690903763'],
  // Sidhpur, Gujarat, Patan
  ['siddhpur', '23.932099623450092, 72.36189004763915'],
  ['sidhpur', '23.932099623450092, 72.36189004763915'],
]);
